var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZupeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.92 60.23C117.13 58.2894 106.892 54.0203 97.92 47.72L104.86 40.78L105.16 40.47L105.25 40.39L103.67 18.73H73.67C70.8799 12.7696 68.87 6.4744 67.69 0L60.23 0C59.0388 6.47414 57.0224 12.7688 54.23 18.73H24.23L22.66 40.78H38.43C27.8117 50.9018 14.4441 57.6673 0 60.23L0 67.69C10.7927 69.628 21.0315 73.901 30 80.21L22.75 87.46L22.67 87.54L24.25 109.18H54.25C57.0411 115.145 59.0574 121.443 60.25 127.92H67.71C68.898 121.442 70.9145 115.143 73.71 109.18H103.71L105.32 87.18H89.49C100.106 77.0543 113.474 70.2881 127.92 67.73V60.23ZM85 85C84.28 85.71 83.58 86.45 82.89 87.19C76.8822 93.6577 72.0134 101.096 68.49 109.19C66.6111 113.526 65.1089 118.016 64 122.61C62.8961 118.011 61.3938 113.518 59.51 109.18C57.2651 104.001 54.4618 99.0815 51.15 94.51L58.52 87.14L94.52 51.14C102.952 57.222 112.496 61.5911 122.61 64C108.365 67.3671 95.3404 74.6394 85 85ZM43 43C43.72 42.28 44.42 41.55 45.11 40.81C51.1128 34.3405 55.9781 26.9023 59.5 18.81C61.3931 14.4507 62.899 9.9333 64 5.31C65.1036 9.90414 66.6025 14.3942 68.48 18.73C70.7322 23.9141 73.5385 28.8394 76.85 33.42L69.49 40.78L33.49 76.78C25.0236 70.7168 15.4492 66.3747 5.31 64C19.5822 60.6422 32.6347 53.3696 43 43Z",
    fill: "#4611A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZupeeIcon);
export default __webpack_public_path__ + "static/media/zupee-icon.63aace315a3352f436ae2b42a5bf1692.svg";
export { ForwardRef as ReactComponent };